import { render } from "./transactions-evolution.vue?vue&type=template&id=1f3d8b24"
import script from "./transactions-evolution.vue?vue&type=script&lang=js"
export * from "./transactions-evolution.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__